import {REQUEST_USER, REQUEST_USER_FAILURE, REQUEST_USER_SUCCESS} from "../../constant/UsersConstant";

const initialState = {
    user: {
        data: [],
        status: 'idle',
        isLoading: true,
    },
};


export const userReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_USER:
            return {
                ...state,
                user: {
                    data: [],
                    status: 'fetching',
                    isLoading: true,
                },
            };
        case REQUEST_USER_SUCCESS:
            return {
                ...state,
                user: {
                    data: payload,
                    status: 'ready',
                    isLoading: false,
                },
            };
        case REQUEST_USER_FAILURE:
            return {
                ...state,
                user: {
                    data: [],
                    status: 'fetching',
                },
            };
        default:
            return state;
    }
}
